import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {UserService} from '@sharedcommon/services/user.service';
import {LoggerService} from '@sharedcommon/services/logger.service';
import {Constants} from '@sharedcommon/util/constants.util';
import {GoogleAnalyticsService} from 'ngx-google-analytics';

@Injectable()
export class NeqGoogleAnalyticsService {


  constructor(
    private readonly router: Router,
    private readonly userService: UserService,
    private readonly loggerService: LoggerService,
    private readonly $gaService: GoogleAnalyticsService
  ) {
  }

  initGoogleAnalytics() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let url = event.urlAfterRedirects;
        if (url.lastIndexOf('/') !== 0) {
          const parts = url.split('/');
          const partsSplitOne = parts.pop();
          const partsSplitTwo = parts.pop();
          const lastSegment = partsSplitOne || partsSplitTwo;  // handle potential trailing slash

          if (Constants.REGEX_UUID.test(lastSegment)) {
            url = url.slice(0, url.lastIndexOf('/') + 1) + 'uuid';
          }
        }
        url = this.loggerService.appCode() + url;

        this.$gaService.event('set', 'page', url);
        if (this.userService.getUser()) {
          this.$gaService.event('set', 'mail', this.userService.getUser().email);
          if (this.userService.getEntity()) {
            this.$gaService.event('set', 'entity', this.userService.getEntity());
          }
          if (this.userService.getActivity()) {
            this.$gaService.event('set', 'activity', this.userService.getActivity());
          }
        }
      }
    });
  }
}
